'use client'
import React, { useMemo } from 'react'
import { BRAND_COLLECTION } from '../utils/constDictionary'
import transformLayout from '../lib/transformLayout'
import { useSelector } from 'react-redux'

const MainContainer = (props) => {
  const {
    pageData,
    websiteTheme: webTheme,
    baseURL,
    loading,
    productLoading,
  } = props

  const { name: pageName, showFilter, entity = {} } = pageData
  let pageLayouts = pageData.layouts
  const { websiteTheme: websiteThemeFromCtx } = useSelector(
    (state) => state.themeName
  )
  const { homeLayoutData } = useSelector((state) => state.commonData)
  if (pageName == 'HOME' && Object.keys(homeLayoutData).length) {
    pageLayouts = homeLayoutData.layouts
  }

  const layouts = useMemo(
    () => transformLayout(pageLayouts, [BRAND_COLLECTION]),
    [pageLayouts]
  )
  const child = React.Children.only(props.children)
  const websiteTheme = webTheme || websiteThemeFromCtx
  return React.cloneElement(child, {
    layouts,
    pageName,
    websiteTheme,
    showFilter,
    entity,
    baseURL,
    loading,
    productLoading, 
  })
}

export default MainContainer
